import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { InlineTableComponent } from '@morningstar/shared/base/base-component/inline-table-component';
import { FilterComponent } from '@morningstar/shared/ui-kit/filter';
import { merge, Subject } from 'rxjs';
import { filter, mergeMap, tap } from 'rxjs/operators';
import { EditTodoDialogComponent } from '../edit-todo-dialog/edit-todo-dialog.component';
import { Todo } from '../todo';
import { TodoService } from '../todo.service';

@Component({
  selector: 'wsg-todo-table',
  templateUrl: './todo-table.component.html',
  styleUrls: ['./todo-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TodoTableComponent extends InlineTableComponent<Todo> implements OnInit, OnDestroy {

  // == CONSTANTS ========================================================

  columnsToDisplay = [
    'todo'
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(FilterComponent, { static: true }) filter: FilterComponent;

  // == ACTIONS ==========================================================

  completeTodo = new Subject<Todo>();
  completeTodo$ = this.completeTodo.asObservable();

  editTodo = new Subject<Todo>();
  editTodo$ = this.editTodo.asObservable();

  // == SIDE EFFECTS =====================================================

  onCompleteTodo$ = this.completeTodo$.pipe(
    mergeMap(todo => this.todoService.addInlineData({
      ...todo,
      complete: true
    })),
    tap(() => this.todoService.getInlineData())
  );

  onEditTodo$ = this.editTodo$.pipe(
    mergeMap(todo => this.dialog.open(EditTodoDialogComponent, { data: todo }).afterClosed()),
    filter(result => result),
    tap(() => this.todoService.getInlineData())
  );

  // == SUBSCRIPTION =====================================================

  subscription = merge(
    this.onCompleteTodo$,
    this.onEditTodo$
  ).subscribe();

  // == LIFECYCLE ========================================================

  constructor(protected dialog: MatDialog,
              protected formBuilder: FormBuilder,
              protected todoService: TodoService) {
    super(todoService, dialog, formBuilder);
  }

  ngOnInit() {
    super.ngOnInit();

    this.initializeTable();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // == HELPERS ==========================================================

  addDefaultGroupToFormArray() {
    throw new Error('Not implemented');
  }

  createFormGroup(todo: Todo) {
    const formGroup = this.formBuilder.group({
      id: todo.id,
      location: todo.location,
      tenantName: todo.tenantName,
      description: todo.description,
      pinType: todo.pinType,
      pin: todo.pin,
      type: todo.type,
      instructionUrl: todo.instructionUrl,
      notes: todo.notes,
      new: false
    });

    if (formGroup.get('id').value) {
      formGroup.get('id').disable();
    }

    return formGroup;
  } 
}
